const BranchListData = {
  Jakarta: [
    {
      name: 'Jakarta Branch',
      address: 'Jakarta Location',
      hours: '10:00 - 21:00',
      phone: '+62 21 1234 5678'
    }
  ],
  Medan: [
    {
      name: 'Boston Branch',
      address: 'Medan Location 1',
      hours: '10:00 - 21:00',
      phone: '+62 61 1234 5678'
    },
    {
      name: 'Arizona Branch',
      address: 'Medan Location 2',
      hours: '10:00 - 21:00',
      phone: '+62 61 8765 4321'
    }
  ]
};

export default BranchListData